module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$store.getters.getUserType === 'USER' || _vm.$store.getters.getUserType === 'ADMIN') ? _c('div', {
    staticClass: "user-home"
  }, [_c('div', {
    staticClass: "share-button"
  }, [_c('button', {
    class: _vm.$i18n.locale() == 'ar' ? 'btn btn-success btn-xs pull-left' : 'btn btn-success btn-xs pull-right',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setShowShare', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Share')))])]), _vm._v(" "), _c('h4', {
    staticClass: "page-top-title"
  }, [_vm._v(_vm._s(_vm.$t('hi')) + ", " + _vm._s(_vm.getUsername))]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t('Thanks for your generous heart. You are changing the world for a lot of people who lost hope')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Country'),
      "id": "country-addon1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Donation Destination')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country),
      expression: "country"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "nationality-addon1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateCountry]
    }
  }, _vm._l((_vm.getApiCountries), function(ctry, i) {
    return _c('option', {
      domProps: {
        "selected": i === 0,
        "value": ctry
      }
    }, [_vm._v(_vm._s(ctry.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-group-vertical btn-block",
    attrs: {
      "role": "group",
      "aria-label": "home-menu-items"
    }
  }, [_c('button', {
    staticClass: "btn btn-default active"
  }, [_vm._v(_vm._s(_vm.$t('Home')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.goToAssociations
    }
  }, [_vm._v(_vm._s(_vm.$t('Charities')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.goToDonations
    }
  }, [_vm._v(_vm._s(_vm.$t('My Donations')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.goToSolidarityAccount
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Solidarity Account')) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.gotToSupportivePOSMap
    }
  }, [_vm._v(_vm._s(_vm.$t('Supportive Establishments')))]), _vm._v(" "), (_vm.$store.getters.getUserType === 'ADMIN') ? _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.goToAdminPage
    }
  }, [_vm._v(_vm._s(_vm.$t('Admin')))]) : _vm._e()]), _vm._v(" "), (_vm.$store.getters.getBalance) ? _c('p', [_vm._v("\n      " + _vm._s(_vm.$t('Total Donations')) + ": "), _c('span', {}, [_vm._v(_vm._s(_vm.$store.getters.getBalance) + " €")])]) : _c('p', [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-fw"
  })])]) : (_vm.$store.getters.getUserType === 'POS') ? _c('div', {
    staticClass: "pos-home"
  }, [_c('div', {
    staticClass: "share-button"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setShowShare', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Share')))])]), _vm._v(" "), _c('h4', {
    staticClass: "page-top-title"
  }, [_vm._v(_vm._s(_vm.$t('hi')) + ", " + _vm._s(_vm.getUsername))]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t('Thanks for your generous heart. You are changing the world for a lot of people who lost hope')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-group-vertical btn-block",
    attrs: {
      "role": "group",
      "aria-label": "home-menu-items"
    }
  }, [_c('button', {
    staticClass: "btn btn-default active"
  }, [_vm._v(_vm._s(_vm.$t('Home')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.goToAssociations
    }
  }, [_vm._v(_vm._s(_vm.$t('Charities')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.gotToSubscription
    }
  }, [_vm._v(_vm._s(_vm.$t('Subscription')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.gotToQRCode
    }
  }, [_vm._v(_vm._s(_vm.$t('My QR Code')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.gotToMap
    }
  }, [_vm._v(_vm._s(_vm.$t('Map')))])])]) : _c('div', {}, [_c('p', [_vm._v("Sorry! this page don't support your user type")]), _vm._v(" "), _c('p', [_vm._v("Type: " + _vm._s(_vm.$store.getters.getUserType))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c05d5f9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 312
// module chunks = 1